import { cn } from '@workspace/ui/lib/utils'

/** The startup's first letter in a square tile, as in the Following designs. */
export function StartupTile({
  name,
  muted = false,
  size = 'md',
}: {
  name: string
  muted?: boolean
  size?: 'md' | 'lg'
}) {
  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center rounded-lg bg-elevated font-semibold',
        size === 'lg' ? 'size-9 text-sm' : 'size-8 text-xs',
        muted ? 'text-muted-foreground/60' : 'text-foreground/80'
      )}
    >
      {name.charAt(0).toUpperCase()}
    </span>
  )
}
